import { getLocalStorage } from './storage';

function getAssetFromLocalStorage(assetId) {
  return getLocalStorage()[assetId];
}

export default getAssetFromLocalStorage;